import React from 'react';
import PropTypes from 'prop-types';
import { emptyArray } from 'ui-components/default-props/empty';

import { ListHeader } from './list-header';
import { UnverifiedRow } from './unverified-row';
import { VerifiedRow } from './verified-row';

import style from './item-list.module.less';

const renderUnverifiedRow = (unverifiedItem = {}, onVerifyItem, onClearItem, currentlyVerifyingItemId, marketplaceId) => (
  <UnverifiedRow
    key={unverifiedItem.itemId}
    currentlyVerifyingItemId={currentlyVerifyingItemId}
    hasMarketplaceAdjustment={unverifiedItem.hasMarketplaceAdjustment}
    imageSrc={unverifiedItem.imageSrc}
    itemId={unverifiedItem.itemId}
    itemQuantity={unverifiedItem.itemQuantity}
    marketplaceId={marketplaceId}
    name={unverifiedItem.name}
    onClear={onClearItem}
    onVerify={onVerifyItem}
    sku={unverifiedItem.sku}
    upc={unverifiedItem.upc}
    verifiedQuantity={unverifiedItem.verifiedQuantity}
  />
);

const renderVerifiedRow = (verifiedItem = {}, onClearItem) => (
  <VerifiedRow
    key={verifiedItem.itemId}
    imageSrc={verifiedItem.imageSrc}
    itemId={verifiedItem.itemId}
    itemQuantity={verifiedItem.itemQuantity}
    name={verifiedItem.name}
    onClear={onClearItem}
    sku={verifiedItem.sku}
    upc={verifiedItem.upc}
    verifiedQuantity={verifiedItem.verifiedQuantity}
  />
);

export const ItemList = ({
  onVerifyItem,
  onClearItem,
  onVerifyAllItems,
  onClearAllItems,
  items = emptyArray,
  currentlyVerifyingItemId = '',
  renderItemVerificationNotification,
  marketplaceId,
}) => {
  return (
    <>
      <div className={style['item-list-container']} id='verify-item-list'>
        <div className={style['item-list']}>
          <ListHeader onClearAllItems={onClearAllItems} onVerifyAllItems={onVerifyAllItems} />
          {items.map((item) => {
            if (item.verified) {
              return renderVerifiedRow(item, onClearItem);
            }
            return renderUnverifiedRow(item, onVerifyItem, onClearItem, currentlyVerifyingItemId, marketplaceId);
          })}
        </div>
      </div>
      {renderItemVerificationNotification()}
    </>
  );
};

ItemList.propTypes = {
  onVerifyItem: PropTypes.func.isRequired,
  onClearItem: PropTypes.func.isRequired,
  onVerifyAllItems: PropTypes.func.isRequired,
  onClearAllItems: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.object),
  currentlyVerifyingItemId: PropTypes.string,
  renderItemVerificationNotification: PropTypes.func.isRequired,
  marketplaceId: PropTypes.string.isRequired,
};
